import createApiService from "../../http";

const ADD_COMMITMENT = "commitments";
const ADD_COMMITMENT_ACTIVITY = "commitmentItems";
const ADD_DATASET = "dataSet";
const DELETE_DATA_CATEGORY = "dataCategory";
const DELETE_SUB_DATA_CATEGORY = 'dataType';
const FETCH_COMMITMENTS = "commitments";

export const fetchCommitmentService = (params) =>
  createApiService({
    method: "get",
    endpoint: FETCH_COMMITMENTS,
    options: {
      params,
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const fetchSingleCommitmentService = (id) =>
  createApiService({
    method: "get",
    endpoint: `${FETCH_COMMITMENTS}/${id}`,
    options: {
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const deleteCommitmentService = (token, data) =>
  createApiService({
    method: "delete",
    endpoint: ADD_COMMITMENT,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
      data: {
        ...data
      }
    },
  });

export const updateCommitmentService = (token, id) =>
  createApiService({
    method: "put",
    endpoint: `${ADD_COMMITMENT}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const createCommitmentService = (token) =>
  createApiService({
    method: "post",
    endpoint: ADD_COMMITMENT,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const createCommitmentActivityService = (token) =>
  createApiService({
    method: "post",
    endpoint: ADD_COMMITMENT_ACTIVITY,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });


export const updateCommitmentActivityService = (token, id) =>
  createApiService({
    method: "put",
    endpoint: `${ADD_COMMITMENT_ACTIVITY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const deleteCommitmentActivityService = (token, id) =>
  createApiService({
    method: "delete",
    endpoint: `${ADD_COMMITMENT_ACTIVITY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const deleteDataCategoryService = ({ token, id }) =>
  createApiService({
    method: "delete",
    endpoint: `${DELETE_DATA_CATEGORY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const deleteSubDataCategory = ({ token, id }) =>
  createApiService({
    method: "delete",
    endpoint: `${DELETE_SUB_DATA_CATEGORY}/${id}`,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });

export const addDataSet = (token) =>
  createApiService({
    method: "post",
    endpoint: ADD_DATASET,
    options: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      baseURL: process.env.REACT_APP_BUDGIT_URL,
    },
  });
